import { useEffect, useState } from "react";
import { Camera, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, compress, errMsg, photoUrl } from "../lib/api";

export const UploadForm = ({ data, email, onDone }) => {
  const mine = data?.entries.find((e) => e.mine);
  const closed = data && !data.config.uploadsOpen;
  const [f, setF] = useState({ name: "", lionName: "", phone: "" });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (mine) setF({ name: mine.name, lionName: mine.lionName, phone: data.myContact?.phone || "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mine?.id, email]);

  const pick = (ev) => {
    const x = ev.target.files?.[0];
    if (!x) return;
    if (!/^image\//.test(x.type) && !/\.(heic|heif|jpe?g|png|webp)$/i.test(x.name)) return toast("Elige una imagen.");
    setFile(x);
    setPreview(URL.createObjectURL(x));
  };

  const submit = async (ev) => {
    ev.preventDefault();
    const name = f.name.trim(), phone = f.phone.replace(/[^\d+]/g, "");
    if (!file && !mine) return toast("Falta la foto de tu león.");
    if (name.length < 2) return toast("Escribe tu nombre.");
    if (phone.replace(/\D/g, "").length < 10) return toast("El celular debe tener al menos 10 dígitos.");
    setBusy(true);
    try {
      const fd = new FormData();
      Object.entries({ email, name, lionName: f.lionName.trim(), phone }).forEach(([k, v]) => fd.append(k, v));
      if (file) fd.append("photo", await compress(file), "leon.jpg");
      await api.saveEntry(fd);
      setFile(null);
      setPreview("");
      toast(mine ? "Cambios guardados." : "¡Tu león ya está en la galería!");
      onDone();
    } catch (e) {
      toast(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const shown = preview || (mine ? photoUrl(mine.photoId) : "");
  const disabled = closed || !email || busy;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <section className="on" data-testid="upload-section">
      <h2>Sube tu león</h2>
      <p className="hint">Una participación por persona. Si ya subiste el tuyo, aquí puedes cambiar la foto o tus datos.</p>
      {closed ? <div className="banner" data-testid="uploads-closed-note">Ya no se reciben leones nuevos. ¡Ve a votar!</div>
        : !email ? <div className="banner err" data-testid="upload-need-email">Primero escribe tu correo arriba para participar.</div>
        : mine ? <div className="banner" data-testid="already-participating-note">Ya estás participando. Si quieres, cambia tu foto o tus datos.</div> : null}
      <form className="f" onSubmit={submit} noValidate data-testid="upload-form">
        <div className="row">
          <label className={`drop${shown ? " has" : ""}`} style={shown ? { backgroundImage: `url("${shown}")` } : {}}>
            <input type="file" accept="image/*" onChange={pick} disabled={disabled} data-testid="upload-photo-input" />
            <Camera size={34} />
            <span>{shown ? "Toca para cambiar la foto" : "Toca para elegir la foto de tu león"}</span>
          </label>
        </div>
        <div className="row"><label htmlFor="name">Tu nombre</label>
          <input type="text" id="name" maxLength={80} value={f.name} onChange={set("name")} disabled={disabled} data-testid="upload-name-input" /></div>
        <div className="row"><label htmlFor="lionName">Nombre de tu león <span>(opcional)</span></label>
          <input type="text" id="lionName" maxLength={60} placeholder="Ej. El Catrín, Calabacín…" value={f.lionName} onChange={set("lionName")} disabled={disabled} data-testid="upload-lionname-input" /></div>
        <div className="two row">
          <div><label htmlFor="email">Correo</label>
            <input type="email" id="email" value={email || ""} readOnly disabled data-testid="upload-email-input" /></div>
          <div><label htmlFor="phone">Celular</label>
            <input type="tel" id="phone" maxLength={20} inputMode="tel" placeholder="10 dígitos" value={f.phone} onChange={set("phone")} disabled={disabled} data-testid="upload-phone-input" /></div>
        </div>
        <p className="privacy"><Lock size={13} /> Tu correo y celular solo los ve el organizador, para contactar al ganador. En la galería solo aparecen tu nombre y tu león.</p>
        <button className="btn full" type="submit" disabled={disabled} data-testid="upload-submit-btn">
          {busy ? "Subiendo…" : mine ? "Guardar cambios" : "Subir mi león"}
        </button>
      </form>
    </section>
  );
};
